<template>
    <div>

        <div style="background-color: #fff; padding: 5px;">
            <i>
                * Nesta tela você poderá realizar solicitações de suporte a SMED ou ao NTI. Solicitações como 
                alterações de cadastro de alunos, sugestões de melhorias no sistema, relatos de falhas/bugs dentre
                outras devem ser cadastradas aqui. Cada usuário só visualiza as suas mensagens de suporte e os administradores 
                visualizam solicitações de todos os usuários.
            </i>
        </div>

        <el-row class="u-mt-10 u-mb-20" :gutter="10">
            <el-col :xs="24" :sm="6" :md="6">            
                <el-select v-model="filtro.status" @change="changeFiltro" clearable>
                    <el-option v-for="(item, i) in $CONSTANTS.STATUS_SUPORTE" :key="i" :label="item" :value="i"></el-option>
                </el-select>
            </el-col>
            <el-col :xs="24" :sm="14" :md="14">
                <el-input v-model="filtro.texto" placeholder="" @keyup.native.enter="changeFiltro"></el-input>
            </el-col>
            <el-col :xs="24" :sm="4" :md="4" class="u-text-right">
                <router-link to="/admin/suporte/cadastro" class="btn-new-register">
                    <el-button type="primary">NOVO SUPORTE</el-button>
                </router-link>
            </el-col>
        </el-row>
        <div class="container-table u-mt-10">
            <table v-loading="!statusList" class="table table-striped">
                <thead>
                    <tr>
                        <th style="width: 70px;">Cod.</th>
                        <th style="width: 150px;">Data</th>
                        <th>Texto</th>
                        <th class="u-text-center">Usuário</th> 
                        <th class="u-text-center" style="width: 150px;">Status</th>                        
                        <th style="width: 150px;" class="u-text-center">Ação</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="item in items" :key="item.id">
                        <td>{{ item.id }}</td>
                        <td>{{ $moment(item.data).format('DD/MM/YYYY HH:mm:ss') }}</td>
                        <td>{{ item.texto | truncate(100, '...') }}</td>
                        <td class="u-text-center">{{ item.usuario.name }}</td>

                        <td v-if="item.status == 1" style="background-color: #fbff00;" class="u-text-center">EM ABERTO</td>
                        <td v-if="item.status == 3" style="background-color: #5ba72c;" class="u-text-center">FINALIZADO</td>
                        <td v-if="item.status == 2" style="background-color: #d69b16;" class="u-text-center">EM ANÁLISE</td>

                        <td class="u-text-center acao"> 
                            <el-button @click="showSuporte(item)" title="Visualizar" type="primary" size="mini">
                                <i class="fas fa-search"></i>
                            </el-button>
                        </td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr v-if="statusList && items.length == 0" style="border-top: 1px solid #ddd;">
                        <td colspan="100%" class="u-text-center">
                            <span>- nenhum registro -</span>
                        </td>
                    </tr>
                    <tr v-if="paginate.qtdItens > 30">
                        <td colspan="100%" class="u-text-right">
                            <el-pagination :total="paginate.qtdItens" @current-change="getPagePagination" :page-size="30" background layout="prev, pager, next" small></el-pagination>
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>

        <el-dialog :close-on-click-modal="false" title="DETALHES DO SUPORTE" width="80%" :visible.sync="infoSuporte" >

            <div class="u-mt-20">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="11" :md="11">
                        <label style="padding: 0 0 5px 5px; line-height: 36px; color: #606266;">INSTITUIÇÃO</label>
                        <div class="style-input" style="background-color: #ebebeb !important;">{{ suporteSelected.instituicao }}</div>                            
                    </el-col>
                    <el-col :xs="24" :sm="7" :md="7">
                        <label style="padding: 0 0 5px 5px; line-height: 36px; color: #606266;">USUÁRIO</label>
                        <div class="style-input" style="background-color: #ebebeb !important;">{{ (suporteSelected.usuario) ? suporteSelected.usuario.name : '-' }}</div>                            
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <label style="padding: 0 0 5px 5px; line-height: 36px; color: #606266;">TELEFONE</label>
                        <div class="style-input" style="background-color: #ebebeb !important;">
                            <a v-if="suporteSelected.telefone" :href="'https://web.whatsapp.com/send?phone=55' + suporteSelected.telefone.replace(/[()\s]/g, '') + '&text=Olá!'" target="_blank">
                                {{ (suporteSelected.telefone) ? suporteSelected.telefone : '-' }}
                            </a>                            
                        </div>                            
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" :md="12">
                        <label style="padding: 0 0 5px 5px; line-height: 36px; color: #606266;">DATA</label>
                        <div class="style-input" style="background-color: #ebebeb !important;">{{ $moment(suporteSelected.data).format('DD/MM/YYYY') }}</div>                            
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12">
                        <label style="padding: 0 0 5px 5px; line-height: 36px; color: #606266;">STATUS</label>
                        <el-select :disabled="$store.state.user.tipo != 4 && $store.state.user.tipo != 5 && $store.state.user.tipo != 6" v-model="formUpdateStatus.status">
                            <el-option v-for="(item, i) in $CONSTANTS.STATUS_SUPORTE" :key="i" :label="item" :value="parseInt(i)"></el-option>
                        </el-select>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <label style="line-height: 25px;"><b>TEXTO</b></label>
                        <el-input :disabled="true" :rows="15" type="textarea" v-model="suporteSelected.texto"></el-input>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" class="u-text-right">
                        <el-button type="danger" @click="infoSuporte = false">FECHAR</el-button>
                        <el-button class="u-ml-10" v-if="$store.state.user.tipo == 4 || $store.state.user.tipo == 5 || $store.state.user.tipo == 6" type="primary" @click="onsubmitUpdateStatus(suporteSelected.id)">SALVAR</el-button>
                    </el-col>
                </el-row>
            </div>

        </el-dialog>

    </div>
</template>
<script>

export default {
    data: () => ({
        infoSuporte: false,
        statusList: false,
        filtro: {
            status: '',
            texto: ''
        },
        suporteSelected: {},
        formUpdateStatus: {
            status: ''
        },
        paginate: {
            page: 1,
            qtdItens: null,
        },
        items: [ ]
    }),
    mounted () {
      this.loadingSuportes()
    },
    methods: {
        changeFiltro(){

            this.paginate.page = 1;
            this.loadingSuportes();
        },
        loadingSuportes(){

            this.statusList = false;
            this.items = [];

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/suporte/getAllPaginate?page=` + this.paginate.page, this.filtro, this.$store.getters.getHeaderAuth).then(response => {

                this.items = response.data.data;
                this.paginate.qtdItens = response.data.total;
                this.statusList = true;

            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        showSuporte(item){

            this.formUpdateStatus.status = item.status;
            this.suporteSelected = item;
            this.infoSuporte = true;

        },
        onsubmitUpdateStatus(id){

            window.eventBus.$emit('loading', true);                

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/suporte/updateStatus/` + id, this.formUpdateStatus, this.$store.getters.getHeaderAuth).then(response => {

                window.eventBus.$emit('loading', false);
                window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                
                this.infoSuporte = false;
                this.loadingSuportes();

            }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });
        },
        getPagePagination(page){
          this.paginate.page = page;
          this.loadingSuportes();
        }
    }
}
</script>